import { INIT_ROOT } from '../actionTypes';
import { get } from 'lodash';

export default function urls(state, action) {
  const urls = get(action.payload, 'appResources.urls') || {};
  switch (action.type) {
    case INIT_ROOT:
      return urls;
    default:
      return state || {};
  }
}
